module.exports = __webpack_public_path__ + "img/37800.747f76a6.jpg";